import request from "@utils/request";

export function getLPAccount(query) {
    return request({
        url: 'lp/account',
        method: 'get',
        params: query
    })
}
